import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {MenuListComponent} from '@modules/administration/menus/components/menu-list/menu-list.component';
import {AuthGuard} from '@core/guard/auth.guard';
import {UserListComponent} from '@modules/administration/users/components/user-list/user-list.component';
import {AccessMenuGuard} from '@core/guard/access-menu.guard';
import {ProfileComponent} from '@modules/administration/profile/profile.component';
import {OrderListComponent} from "@modules/administration/orders/components/order-list/order-list.component";
import {ViewReportComponent} from "@modules/administration/report/components/view-report/view-report.component";


export const ROUTES = {
  PREFIX: 'administration',
};

const routes: Routes = [
  {
    path: 'menus',
    component: MenuListComponent,
    canActivate: [AuthGuard, AccessMenuGuard],
    data: {
      title: 'Danh mục menu',
      canActive: 'MENUS'
    }
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard, AccessMenuGuard],
    data: {
      title: 'Thông tin người dùng'
    }
  },
  {
    path: 'orders',
    component: OrderListComponent,
    canActivate: [AuthGuard, AccessMenuGuard],
    data: {
      title: 'Danh sách đơn hàng',
      canActive: 'ORDER_MANAGEMENT'
    }
  },
  {
    path: 'users',
    component: UserListComponent,
    canActivate: [AuthGuard, AccessMenuGuard],
    data: {
      title: 'Danh sách người dùng',
      canActive: 'USERS'
    }
  },
  {
    path: 'summaryOrder',
    component: ViewReportComponent,
    canActivate: [AuthGuard, AccessMenuGuard],
    data: {
      title: 'Báo cáo đơn hàng',
      canActive: 'SUM_ORDER'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministrationRoutingModule { }
